import React, { FC } from 'react';
import { Button, Drawer } from 'antd';

interface IComponentProps {
  open: boolean;
  subtitle: string;
  content: string;
  btnTitle?: string;
  loading?: boolean;
  onClose: () => void;
  onConfirm?: () => void;
}

export const SuccessCard: FC<IComponentProps> = ({ open, subtitle, content, btnTitle, loading, onClose, onConfirm }) => {
  return (
    <Drawer rootClassName="redesign drawer success-card" open={open} onClose={onClose} width={720} destroyOnClose>
      <div className="drawer__body">
        <span className="text-h3 color-white-40 success-card__subtitle">{subtitle}</span>

        <div className="drawer__title color-white">{content}</div>
      </div>

      {onConfirm && (
        <div className="drawer__footer">
          <Button className="button-lg green" onClick={onConfirm} loading={loading}>
            {btnTitle}
          </Button>
        </div>
      )}
    </Drawer>
  );
};
